export default __webpack_public_path__ + "static/media/close-chat.536c11ae.svg";